import React from 'react';
import { Field, useForm } from 'react-final-form';

import { CardType } from '../../../../types/cardType';
import Checkbox from '../../../Checkbox/Checkbox';
import type { Props } from '../../SavePaymentInfo';
import { fastDepositField, saveCardField } from '../../SavePaymentInfo';

import { TXTWCL_Save_this_as_my_preferred_paym_ELL } from './FirstTimeDepositCheckboxes.messages.json';

const FirstTimeDepositCheckboxes: React.FC<Props> = ({ type }) => {
  const form = useForm();
  const disabled = [CardType.ECheck, CardType.Pix, CardType.Skrill1Tap].includes(type);

  return (
    <>
      <Field name={saveCardField} type="checkbox" initialValue={disabled}>
        {({ input: { onChange, checked } }) => (
          <Checkbox
            name={saveCardField}
            checked={checked}
            onChange={(event) => {
              onChange(event);
              checked && form.change(fastDepositField, undefined);
            }}
            label={TXTWCL_Save_this_as_my_preferred_paym_ELL}
            disabled={disabled}
          />
        )}
      </Field>
      <Field name={fastDepositField} type="checkbox" component={() => null} />
    </>
  );
};

export default FirstTimeDepositCheckboxes;
